import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../config/api' // Импортируем ваш axios-экземпляр

const LogoutPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const logout = async () => {
      try {
        // Отправляем запрос на бэкенд для выхода (если требуется)
        await api.post('/API_FRONT/logout/') // Укажите ваш эндпоинт выхода

        // Очищаем localStorage от токенов
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')

        // Очищаем CSRF-токен (для Django)
        document.cookie =
          'csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

        // Перенаправляем на страницу входа
        navigate('/login')
      } catch (error) {
        console.error('Logout failed:', error)
        // Даже если запрос не удался, очищаем токены на клиенте
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        navigate('/login')
      }
    }

    logout()
  }, [navigate])

  return (
    <div className="logout-page">
      <h2>Выход из системы...</h2>
      <p>Пожалуйста, подождите, выполняется выход.</p>
    </div>
  )
}

export default LogoutPage
